import React from 'react';
import { Layout } from 'antd';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { useBreadcrumbs, useBreadcrumbsContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext, useMenuLevelOneContext, useMenuLevelOneElementContext, useMenuLevelThreeContext, useMenuLevelThreeElementContext, useMenuLevelTwoContext, useMenuLevelTwoElementContext } from '../../../common/Context';
import LevelBreadcrumbs from '../LevelBreadcrumbs';
import CapsuleMenu from '../CapsuleMenu';
// import SideMenu from '../SideMenu';

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function PageLayout(props) {
    const { children, hideSider, hideBreadcrumbs, top, bottom, sider } = props;
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    // const siteAccess = useSelector(state => state.siteAccess.value);

    // const role_by_id = useSelector(state => state.home.role_by_id);
    // const status = useSelector(state => state.home.status, () => { }); // Статусы
    // const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

    // const breadcrumbs = useBreadcrumbsContext()
    const breadcrumbs = useBreadcrumbs()


    const menuLevelOne = useMenuLevelOneContext()
    const menuLevelTwo = useMenuLevelTwoContext()
    const menuLevelThree = useMenuLevelThreeContext()
    const getLast = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array[loc_array.length - 1]
        if (!lst) return;
        return lst
    }
    const getBase = (path) => {
        if (!path) return;
        var loc_array = path.split("/")
        var lst = loc_array.slice(0, -1)
        return lst.join("/")
    }
    const getLevel = (arr, i) => {
        let p = "/app"
        var count = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            if (count >= i) return p;
            if (!arr[idx]?.context) {
                count++
            }
            p += `/${arr[idx]?.uuid}`
        }
        return p
    }

    return (
        <div style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
        }}>
            {!hideBreadcrumbs && <Layout style={(!isDesktopOrLaptop) ? {flex: "0 0 auto"} : {flex: "0 0 auto", width: layoutWidth, margin: "0 auto" }}>
                <div style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "3px" }}>
                    <div style={{ padding: "2px" }}>
                        {(!!top)?top():<LevelBreadcrumbs elements={breadcrumbs}/>}
                    </div>
                </div>
            </Layout>}
            <Layout style={(!isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" }}>
                {!hideSider && <Layout.Sider width={40} theme="light" style={{ borderRadius: "4px" }}>
                    {(!!sider)?sider(): <div>
                        {/* <SideMenu noDivider={true} menu={menuLevelTwo} path={"/app/:one/:id?/:uuid/:idtwo?/:three"} levelCorrection={2} /> */}
                        {/* <SideMenu menu={menuLevelThree} path={"/app/:one/:id?/:two/:idtwo?/:uuid"} levelCorrection={1} /> */}
                        
                        {/* <TabsMenu menu={menuLevelTwo} path={getLevel(breadcrumbs, 2)} /> */}
                        {/* <TabsMenu menu={menuLevelThree} path={getLevel(breadcrumbs, 3)} /> */}
                    </div>}
                </Layout.Sider>}
                <Layout.Content style={{ height: "100%", padding: (hideSider)?"0px":"0px 0px 0px 3px" }}>
                    {children}
                </Layout.Content>
            </Layout>
            {bottom && <Layout style={(!isDesktopOrLaptop) ? {flex: "0 0 auto"} : {flex: "0 0 auto", width: layoutWidth, margin: "0 auto" }}>
                <div style={{ backgroundColor: "white", borderRadius: "4px", marginBottom: "3px" }}>
                    <div style={{ padding: "2px" }}>
                        {bottom()}
                    </div>
                </div>
            </Layout>}
        </div>
    );
}
